import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const defaultR2BReferralBrand: R2BReferralBrandEntity = {
  token: "default",
  type: "r2bReferralBrand",
  name: "Default Referral Brand",
  website: "https://example.com",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
